// src/components/ProtectedRoute.js
import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

export default function ProtectedRoute({ children }) {
    const [checking, setChecking] = useState(true);
    const [user, setUser] = useState(null);

    useEffect(() => {
        const auth = getAuth();
        const unsub = onAuthStateChanged(auth, u => {
            setUser(u);
            setChecking(false);
        });
        return () => unsub();
    }, []);

    if (checking) {
        // you can return a spinner here
        return null;
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    return children;
}